export const APP_CHANGELOG = [
  {
    version: '3.0.0002',
    date: '27.04.2026',
    title: 'Обновление Salew Bot',
    items: [
      'Мелкое улучшение.',
    ],
  },
];

export const getLatestChangelogEntry = () => APP_CHANGELOG[0] || null;
